module.exports = __webpack_public_path__ + "static/media/blueSMS.5b0a9620.svg";